import {KTCard} from '../../../../_metronic/helpers'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {Metric} from './components/Metric'
import {FormProvider} from './core/FormProvider'

const groupBreadcrumbs: Array<PageLink> = [
  {
    title: 'Relatório Resumo',
    path: '/reports/reportSummary/list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ReportSummaryPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={groupBreadcrumbs}>Relatório Resumo</PageTitle>
      <>
        <KTCard>
          <FormProvider>
            <Metric />
          </FormProvider>
        </KTCard>
      </>
    </>
  )
}

export default ReportSummaryPage
